import { FC, useContext } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { ReactComponent as DeleteFileIcon } from 'assets/icons/close-circle.svg';
import { ReactComponent as UploadIcon } from 'assets/icons/document-upload.svg';
import { useFormikContext } from 'formik';
import { IParserForm } from 'pages/DataSettingsPage/DataSettings/DataSettingForm/config';
import SocketContext from 'socket/DataSettingsSocket/context';
import { UPLOAD_PROVIDERS, UploadField } from 'types/upload-status';
import { UploadProgress } from './UploadProgress';
import styles from './index.module.scss';

interface IUploadFile {
	title: string;
	fieldName: UploadField;
	fileFormat: string;
	isDisabled: boolean;
}

export const UploadFile: FC<IUploadFile> = ({ fieldName, title, fileFormat, isDisabled }) => {
	const { values, setFieldValue } = useFormikContext<IParserForm>();
	const { providerUploads } = useContext(SocketContext);
	const upload = providerUploads[UPLOAD_PROVIDERS[fieldName]];

	const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files && e.target.files[0];

		if (fieldName && file) {
			setFieldValue(fieldName, file);
		}
	};

	const handleClearFile = () => {
		setFieldValue(fieldName, null);
	};

	return (
		<Box>
			<Box className={styles.wrapper}>
				<Typography variant="body2" color={isDisabled ? 'text.disabled' : 'text.primary'}>
					{title}
				</Typography>
				{values[fieldName] ? (
					<Box
						className={styles.file_name}
						sx={{
							opacity: isDisabled ? 0.3 : 1,
						}}
					>
						<Typography variant="button">{(values[fieldName] as File).name}</Typography>
						{/*<Button aria-label={fieldName} component="span" disabled={isDisabled}>*/}

						<Button
							aria-label={`Видалити файл: ${title}`}
							type="button"
							disabled={isDisabled}
							onClick={handleClearFile}
						>
							<DeleteFileIcon />
						</Button>
					</Box>
				) : (
					<label htmlFor={fieldName}>
						<input
							id={fieldName}
							name={fieldName}
							accept={fileFormat}
							disabled={isDisabled}
							type="file"
							onChange={handleFileChange}
							style={{ display: 'none' }}
						/>
						<Button aria-label={fieldName} component="span" disabled={isDisabled}>
							<UploadIcon title={fileFormat} opacity={isDisabled ? 0.3 : 1} />
						</Button>
					</label>
				)}
			</Box>
			{upload && <UploadProgress {...upload} />}
		</Box>
	);
};
